import { createClient } from '@supabase/supabase-js';

/**
 * Supabase Configuration
 * 
 * This file provides functions to create Supabase client instances with proper authentication.
 */

// Supabase project credentials
export const SUPABASE_URL = 'https://ydjgxcpbbnhoucqqctds.supabase.co';
export const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inlkamd4Y3BiYm5ob3VjcXFjdGRzIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDQ5MTk0MjUsImV4cCI6MjA2MDQ5NTQyNX0.7d_9ndyz2Ea0cYDpC3-mTnKd6mY9VWOcwDPvK6liNI8';

// Create a basic Supabase client without auth
const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);

// Function to create a Supabase client with authorization
export const createSupabaseWithAuth = (token) => {
  if (!token) {
    return supabase;
  }
  
  // Create a new Supabase client with the authorization token
  return createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
    global: {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  });
};

export default supabase;
